import type { EUROPACE_PROCESS_PLATFORM, User } from 'cpool-constants';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';
import { type UseFormGetValues } from 'react-hook-form';

import type { SchemaCreditRequestForm } from '../schemas/creditRequestForm.schema';
import { getMatchingEuropacePlatformPartnerId } from '~/features/leadDetails/utils/getMatchingEuropacePartnerId';
import { buildOfferRequestConditionsPayload } from '../../utils/buildOfferRequestConditionsPayload';

type Props = {
    getValues: UseFormGetValues<SchemaCreditRequestForm>;
    lead: SchemaLoanRequestResolver_Get;
    user: User | null;
    offerRequestId: string;
};

export const buildRequestOffersPayload = ({ getValues, lead, offerRequestId, user }: Props) => {
    let europacePlatform: EUROPACE_PROCESS_PLATFORM | null = null;

    // if the europace process is imported, we use the platform from the lead
    if (lead?.europace?.id && lead?.europace?.platform) {
        europacePlatform = lead.europace.platform;
    }

    const { partnerId: europacePartnerIdToUse, platform: europacePlatformToUse } = getMatchingEuropacePlatformPartnerId(
        europacePlatform,
        user,
    );

    const conditionsPayload = buildOfferRequestConditionsPayload({
        getValues,
        coApplicantHidden: lead.coApplicantHidden,
    });

    return {
        conditions: conditionsPayload.conditions,
        europace: {
            partnerId: europacePartnerIdToUse,
            platform: europacePlatformToUse,
        },
        id: offerRequestId,
        loanRequestId: lead.id,
    };
};
